import { GraphQLClient } from 'graphql-request';
import { getAuth } from 'firebase/auth';

import { token } from '../helpers/axios_client';
import { authReady } from '../firebase/authReady';

// @ts-ignore
const host = import.meta.env.VITE_ENDPOINT;
const endpoint = `${host}/graphql`;

/**
 * Get the current Firebase auth token if available.
 * Waits for Firebase auth state to be determined before checking currentUser,
 * so requests aren't sent unauthenticated during the brief window while
 * Firebase restores the session from localStorage.
 */
async function getFirebaseToken(): Promise<string | null> {
  try {
    await authReady;
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      // Get a fresh token (force refresh if close to expiry)
      return await user.getIdToken();
    }
  } catch (error) {
    console.warn('[GraphClient] Failed to get Firebase token:', error);
  }
  return null;
}

// Create a GraphQL client with async requestMiddleware to inject auth headers.
// Note: graphql-request v7's `headers` option does NOT support async functions
// (callOrIdentity doesn't await promises), but requestMiddleware IS awaited.
const graphClient = new GraphQLClient(endpoint, {
  headers: {
    App: 'Web',
  },
  requestMiddleware: async (request) => {
    const csrfToken = (token as HTMLMetaElement)?.content || (token as { content: string })?.content || '';
    const firebaseToken = await getFirebaseToken();

    const headers = new Headers(request.headers);
    headers.set('X-CSRF-Token', csrfToken);
    if (firebaseToken) {
      headers.set('Authorization', firebaseToken);
    }

    return { ...request, headers };
  },
});

export default graphClient;
